// extracted by mini-css-extract-plugin
export var integrationButton = "_9t-0";